import React, { PureComponent } from 'react';
import { View } from 'react-native';
import { createContainer } from '@dbk-legacy/muster/react';
import { Large, Small } from '@dbk/ui-text';
import format from 'date-fns/format';
import {
  NavigationListItem,
  NavigationListItemHeader,
  NavigationListItemContent,
  NavigationListItemFooter,
} from '@dbk/ui-list';
import Spinner from '@dbk/ui-spinner';
import { ScrollView } from '@dbk/ui-react-utils';
import { ROUTES, PALETTE, PAYMENT_STATUS, EBANKINGWEBLUX, RM_REGION, EBANKINGWEB, RM_REGION_CH, KEY_CODE} from '../../../../constants'
import paymentData from '../../../../data/paymenttypes.json';
import {Currency} from '../../../../components/common/number';
import styles, {centerSpinner}  from './index.styles';
import { ShortDate } from '@dbk/ui-dates';
import envConfig from '../../../../../db-env-build';

const alignRightStyle = {flex: 1, alignItems: 'flex-end'};

class PaymentDashboard extends PureComponent {
  componentDidMount() {
    //on language change send refetch (forceUpdate as per muster) to update the payments page as per language
    const prevLang=localStorage.getItem('PrevSelectedLanguage');
    const currentLang=localStorage.getItem('SelectedLanguage');
    const newPayFlg=localStorage.getItem('newPaymentComplete');
    const refetch=(prevLang!==currentLang && prevLang!==null)||newPayFlg || envConfig.rmRegion === RM_REGION || envConfig.rmRegion === RM_REGION_CH ?'refetch':'';
    this.props.payments.setDisableTabs(false);
    if (!this.props.payments.filterFlag)
      this.props.payments.getPaymentHistory(refetch);

    localStorage.setItem('PrevSelectedLanguage',localStorage.getItem('SelectedLanguage'));
    localStorage.removeItem('newPaymentComplete');
  }

  getPaymentTypeKey = paymentTypeName => {
    const defaultKey = paymentData.options[0].key
    const paymentTypeObj = paymentData.options.find(e => e.name===paymentTypeName)
    return paymentTypeObj ? paymentTypeObj.key : defaultKey
  }

  goSummary = (orderId, paymentType, paymentTypeDesc, e) => {
    if((e && e.keyCode && (e.keyCode === KEY_CODE.ENTER_KEY || e.keyCode === KEY_CODE.SPACE_KEY)) || ((paymentType || orderId) && !e)){
      this.props.payments.resetTemplateVariables();
      this.props.payments.fetchTx({ orderId, paymentType, paymentTypeDesc });
      this.props.changePage(ROUTES.PAYMENT.TX_SUMMARY);
    }
  }
  
  render() {
    const {
      i18n: { messages } ,
      payments: {
        filterFlag,
        transactionListLoading: isLoading,
        transactionList,
        filteredPayments,
      }
    } = this.props;
    if(isLoading)
      return <View style={centerSpinner}><Spinner size="large"/></View>

    const data = filterFlag ? filteredPayments : transactionList
    if(!data || !data.length) {
      const msg = messages['app.payments.nopayment.message']
      return <View accessible={true}><Large>{msg}</Large></View>
    }
    return (
      <div className="payment-dashboard">
        
         <View style={styles.mainContainer} >
            <NavigationListItemHeader>
            <NavigationListItemContent tabIndex="0" role="presentation" color={PALETTE.primaryText}  className="paymentListColumn accordionContent">{messages['app.payment.beneDetail.beneficiaryName']}</NavigationListItemContent>
            <NavigationListItemContent tabIndex="0" role="presentation" color={PALETTE.primaryText}  className="paymentListColumn">{messages['app.payment.beneDetail.paymentType']}</NavigationListItemContent>
            <NavigationListItemContent tabIndex="0" role="presentation" color={PALETTE.primaryText}  className="paymentListColumn accordionContent">{messages['app.payments.Iban.text']}</NavigationListItemContent>
            <NavigationListItemContent tabIndex="0" role="presentation" color={PALETTE.primaryText}  className="paymentListColumn">{messages['app.payment.beneDetail.executionDate']}</NavigationListItemContent>
            <NavigationListItemContent tabIndex="0" role="presentation" color={PALETTE.primaryText}  className="paymentListColumn paymentListCotent">{messages['app.common.portfolio.fx.currency']}</NavigationListItemContent>
            <NavigationListItemContent tabIndex="0" role="presentation" color={PALETTE.primaryText} className="paymentListColumn">{messages['app.report.transactionHistory.amount']}</NavigationListItemContent>
            <NavigationListItemContent tabIndex="0" role="presentation" color={PALETTE.primaryText} className="paymentListColumn">{messages['app.documentUploadHistory.status']}</NavigationListItemContent>
            </NavigationListItemHeader>
          </View>
        <ScrollView>
          {data.map(({
            orderId,
            paymentStatus,
            executionDate,
            beneficiaryDetails: {
              firstName: description,
              accountNo,
              bpId
            },
            paymentType: { paymentTypeName, paymentTypeDesc },
            currency: { isoCode },
            currency,
            debitAmount
          }) => {
            let color = PALETTE.paymentPending;
            const dwoStatus = paymentStatus ? paymentStatus.dwoStatus : PAYMENT_STATUS.PENDING
            if (dwoStatus.toUpperCase() === PAYMENT_STATUS.EXECUTED ) color = PALETTE.paymentExecuted
            else if (dwoStatus.toUpperCase() === PAYMENT_STATUS.DELETED || dwoStatus.toUpperCase() === PAYMENT_STATUS.REVERSED || dwoStatus.toUpperCase() === PAYMENT_STATUS.REJECTED) color = PALETTE.paymentDelRev
            const paymentTypeKey = this.getPaymentTypeKey(paymentTypeName)
            const execDate = format(executionDate, 'DD MMM YYYY')
            let statusDescription = ''
            if(paymentStatus) statusDescription = paymentStatus.statusDescription

            const currencyValue = isoCode !== "" && isoCode !== null ? isoCode : null;
            const formatter = new Intl.NumberFormat(this.props.auth.langCode);

            let formattedCurrency = "";
            if(currencyValue){    
              for(let i = 0; i < currencyValue.length; i++)
                formattedCurrency += (currencyValue[i] + " ");
            }
            return (
              <NavigationListItem
                key={orderId}
                // role="listitem"
                // aria-label={"navigationList"}
                ariaLabel={messages['app.accessibility.payment.paymentDetails']} // for arrow key to read out
                tabIndex={-1}
                inverse
                onKeyDown={(e) => this.goSummary(orderId, paymentTypeKey, paymentTypeDesc, e)}
                onClick={() => this.goSummary(orderId, paymentTypeKey, paymentTypeDesc)}
                style={{ backgroundColor: '#12213c'}}
                className="paymentListAccessible">
                <NavigationListItemHeader>
                { (envConfig.envConfig === EBANKINGWEBLUX || envConfig.rmRegion === RM_REGION) && paymentTypeName === "INTERNAL_PAYMENT" ? <NavigationListItemContent tabIndex={0}className="paymentListColumn accordionContent">{bpId}</NavigationListItemContent> :
                    <NavigationListItemContent tabIndex={0} className="paymentListColumn accordionContent">{description}</NavigationListItemContent>}
                  <NavigationListItemContent tabIndex={paymentTypeDesc? 0 : -1} className="paymentListColumn">{paymentTypeDesc}</NavigationListItemContent>
                  <NavigationListItemContent tabIndex={0} className="paymentListColumn accordionContent">{accountNo}</NavigationListItemContent>
                  <NavigationListItemContent tabIndex={0} className="paymentListColumn"><ShortDate value={new Date(execDate)} /></NavigationListItemContent>
                  <NavigationListItemContent tabIndex={0} className="paymentListColumn paymentListCotent" aria-label={formattedCurrency}>{isoCode}</NavigationListItemContent>
                  <NavigationListItemContent tabIndex={0} className="paymentListColumn">
                     {/* EBANK-13231 : Number representation in German  */}
                  { Object.keys(currency).length !== 0 && currencyValue !== null && debitAmount !== null ?
                    <span>
                      <Currency
                          value={debitAmount}
                          renderProps={{
                            size: 'small',
                            style: styles.currencyColor
                          }}
                        />
                    </span>
                    :
                    <span tabIndex="0"><Small>{formatter.format(debitAmount)}</Small></span>
                    }</NavigationListItemContent>
                  <NavigationListItemContent className="paymentListColumn" tabIndex={0} color={color}>{statusDescription}</NavigationListItemContent>
                </NavigationListItemHeader>
              </NavigationListItem>
            )
          })}
        </ScrollView>
      </div>
    )
  }
}
export default createContainer({
  $renderLoading: () => <Spinner size="large"/>,
  $queries: {
    i18n: {
      messages: true
    },
    payments: {
      getPaymentHistory: { $call: 'getPaymentHistory' },
      fetchTx: { $call: 'fetchTx' },
      transactionList: true,
      transactionListLoading: true,
      filteredPayments: true,
      filterFlag: true,
      disableTabs:true,
      setDisableTabs: { $set: 'disableTabs'},
      resetTemplateVariables: { $call: 'resetTemplateVariables'}
    },
    changePage: { $call: 'ui.history.push' },
    auth: {
      langCode: true
    }
  }
})(PaymentDashboard);
